import type { FaireProductEntity } from "../../entity_types/product";

export const p_3b5tmupxdg: FaireProductEntity = {
  token: "p_3b5tmupxdg",
  type: "product",
  name: "White Evil Eye Beaded Necklace - Handcrafted Turkish Jewelry",
  brandToken: "b_eh970f9ptb",
  brandName: "Loli",
  imageUrl:
    "https://cdn.faire.com/fastly/9453bd66c9a98263ccd38012ec13c8522e7af1271a24ebbeb8268112df25457c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c24c43eb886965cf8587fefa79aada9d960f42a261b0b900c699c224fdde9fc.png",
    "https://cdn.faire.com/fastly/fb236c4e89ee0e58fc19ce5aca24275633682cbc71c1df12b7161910ae338418.png",
    "https://cdn.faire.com/fastly/669cda077e4edaa91b8f1cfb8c843658fd95c0ab08bbebe26a6013016213890f.png",
    "https://cdn.faire.com/fastly/109208249e7f4101489a146263454d9b67948b7dce662941013f42c925dcc781.png",
    "https://cdn.faire.com/fastly/b23e246b82eef203e7a1fd2b073cfcd613ef4f55a4485ecebd0781faabaf725d.png",
  ],
  priceDollars: 2.77,
  description:
    "Discover the perfect blend of tradition and contemporary design with our White Evil Eye Beaded Necklace. Each bead is meticulously handcrafted, reflecting the artistry and craftsmanship passed down through generations in Turkey. The centerpiece of this necklace is the iconic evil eye charm, revered for its protective qualities and believed to ward off negative energy.\n\nThis necklace is not just a piece of jewelry; it’s a symbol of protection, elegance, and cultural heritage. Available in various color options, it allows you to personalize your look while maintaining the timeless appeal of the evil eye. Whether you’re looking to elevate your everyday wear or add a meaningful touch to a special occasion, this quick-selling necklace is a versatile addition to any jewelry collection.\n\nWear it alone for a subtle statement or layer it with other pieces for a more dynamic look. With its exquisite craftsmanship and spiritual symbolism.",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:40.377Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
